import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Well, FormHeading, Form } from '../../../form';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ErrorList from '../../../errorList';
import { IEditThemeRouteParams } from './types';
import ThemeForm from '../form';
import updateTheme from './updateTheme';
import deleteTheme from './deleteTheme';
import schema from '../form/schema';
import { useDataFetcher } from '../../../hooks';
import {
  ConfirmationModal,
  IConfirmationModalProps,
  INotificationModalProps,
  NotificationModal,
  useModal,
} from '../../../modals';
import { IApiError } from '../../../../services';

export const EditThemePage: React.FC = () => {
  const history = useHistory();
  const { showModal, hideModal } = useModal();

  const { id } = useParams<IEditThemeRouteParams>();

  const [deleteErrors, setDeleteErrors] = useState<Array<string>>([]);

  const { busy, errors, data: theme } = useDataFetcher(`api/themes/${id}`);

  const handleDelete = () => {
    const confirmationProps: IConfirmationModalProps = {
      title: 'Delete Theme',
      message: 'Are you sure that you to permanently delete this theme?',
      icon: ['far', 'question-circle'],
      kind: 'danger',
      onConfirmed: () => {
        hideModal();

        deleteTheme(+id)
          .then(() => history.replace('/admin/themes'))
          .catch((error: IApiError) => {
            if (error && error.errorNumber === 1006) {
              const props: INotificationModalProps = {
                title: 'Unable to delete theme',
                message:
                  'This theme cannot be deleted because it is being used by one or more sites.',
                icon: ['far', 'info-circle'],
                kind: 'info',
                onRequestClose: () => {
                  hideModal();
                },
              };

              showModal(NotificationModal, props);
            } else {
              setDeleteErrors(error.messages);
            }
          });
      },
      onRequestClose: () => hideModal(),
    };

    showModal(ConfirmationModal, confirmationProps);
  };

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Theme" subTitle="Edit" backPath="/admin/themes" />
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading theme"
          errors={errors}
        >
          <ErrorList errors={deleteErrors} />
          <Form
            initialValues={theme}
            promise={updateTheme}
            validationSchema={schema}
            onSubmit={() => history.push('/admin/themes')}
          >
            <ThemeForm onDelete={handleDelete} />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
